//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SmartImage from '~/components/SmartImage';
import TaskModel from '~/model/TaskModel';
import TaskChatDialog from '~/components/chat/TaskChatModal.vue';

export default {
  components: {
    SmartImage,
  },
  props: {
    customerId: { type: String, default: '' },
    order: { type: Object, required: true },
    timer: { type: Number, default: 0 },
    dataProtectionMode: { type: String, defauolt: '' },
  },
  data() {
    return {
      taskStatus: '',
      taskSuffix: '',
      taskTag: {},
    };
  },
  watch: {
    order(newVal) {
      const model = new TaskModel(newVal.task);
      this.taskModel = model;
      this.taskTag = model.getTaskTag(this.order);
      this.taskStatus = this.$t(this.taskTag.text);
      this.taskSuffix = this.taskTag.suffix || '';
      this.$forceUpdate();
    },
  },
  created() {
    const model = new TaskModel(this.order.task);
    this.taskModel = model;
    this.taskTag = model.getTaskTag(this.order);
    this.taskStatus = this.$t(this.taskTag.text);
    this.taskSuffix = this.taskTag.suffix || '';
  },
  methods: {
    call() {
      // extracted to a method so that bi event would pass
      const newWnd = window.open(
        'tel:' + this.order.task.supportNumber,
        '_self'
      );
      newWnd.opener = null;
    },
    openChat(chatId) {
      this.$root.$emit('open-dialog', {
        component: TaskChatDialog,
        title:
          this.$t('common.message') +
          ' ' +
          this.order.worker.firstName +
          ' ' +
          this.order.worker.lastName,
        params: { chatId },
      });
    },
    getTimerText() {
      const model = new TaskModel(this.order.task);
      const timerText = model.getFormattedTimerText(null, this.order);
      // console.log(timerText, this.order, this.order.task);
      return timerText;
    },
  },
};
